import { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";

// Awards & Recognition strip for a surface ('homepage' | 'about'). Hidden when no published records.
export function AwardsSection({ surface, overline = "Recognition", heading = "Awards & Recognition", dark = false }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(`/cms/awards/${surface}`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [surface]);
  if (rows.length === 0) return null;
  const Wrap = ({ children }) => children;
  return (
    <section data-testid={`awards-section-${surface}`} className={dark ? "bg-forest" : "bg-white"}>
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        {overline && <div className={`overline text-center ${dark ? "text-gold" : "text-saffron"}`}>{overline}</div>}
        {heading && <h2 className={`mt-2 text-center font-display text-2xl font-bold sm:text-3xl ${dark ? "text-cream" : "text-charcoal"}`}>{heading}</h2>}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-8">
          {rows.map((a) => {
            const inner = (
              <div key={a.id} data-testid={`award-${a.id}`} className="flex flex-col items-center gap-2 text-center">
                {a.logo
                  ? <img src={fileUrl(a.logo)} alt={a.logo_alt || a.title} className="h-16 w-auto max-w-[160px] object-contain" />
                  : <div className={`font-display text-sm ${dark ? "text-cream" : "text-charcoal"}`}>{a.title}</div>}
                <div className={`max-w-[160px] text-[11px] ${dark ? "text-cream/70" : "text-muted-foreground"}`}>{a.issuer || a.type}</div>
              </div>
            );
            return a.verification_url
              ? <a key={a.id} href={a.verification_url} target="_blank" rel="noopener noreferrer nofollow">{inner}</a>
              : <Wrap key={a.id}>{inner}</Wrap>;
          })}
        </div>
      </div>
    </section>
  );
}
